export type StringListOrUndef = string | string[] | undefined;

/**
 * Merge all items passed in into a list, note: all arrays will be decomposed
 * @param inlist - original list, if not available a new one will be created.
 * @param items - variable length argument list containing either lists of string or strings.
 * @returns string list if there were items to append, or undefined if nothing found.
 */
const appendItem = (...items: StringListOrUndef[]): string[] | undefined => {
  if (!items || items.length < 1) {
    return undefined;
  }
  const out = items.reduce((acc: Set<string>, val: StringListOrUndef) => {
    if (typeof val === 'string') {
      acc.add(val);
      return acc;
    }
    if (Array.isArray(val)) {
      val.forEach(v => {
        if (typeof v === 'string') {
          acc.add(v);
        }
      });
      return acc;
    }
    return acc;
  }, new Set());
  if (out.size < 1) {
    return undefined;
  }
  return [...out.keys()];
};

export default appendItem;
